import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';


/**
 * Función para listar los movimientos registrados como depósitos bancarios
 * @param {*} param0 
 * @returns 
 */
export const useFetchAllTransactions = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({})

    // 1. Para los datos recuperados de la BD
    const [dataTransactions, setDataTransactions] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataTransactions([])
        setParamsToSearch({})
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/admin-payments/all-movimientos`)
            // console.log('[useFetchData][useFetchAllTransactions] response.data ', response.data)
            // return response.data
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idpago !== '' ){
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataTransactions(resp.rows)
                    setDataTransactions(resp.data)
                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataTransactions, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

/**
 * Función para obtener info de un movimiento especifco (para visualizar detalles)
 * @param {*} param0 
 * @returns 
 */
export const useFetchSpecificTransaction = ({marvarApi, dispatch, onLogout}) => {

    const [paramsToSearch, setParamsToSearch] = useState({
        idmovimiento: '',
        fecthTransactionInfo: {
            flag: false,
            refSetFormState: null
        }
    })

    // 1. Para los datos recuperados de la BD
    const [dataSpecificTransaction, setDataSpecificTransaction] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchTransactions, setLoadingFetchTransactions ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setDataSpecificTransaction([])
        setParamsToSearch({
            idmovimiento: '',
            fecthTransactionInfo: {
                flag: false,
                refSetFormState: null
            }
        })
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/admin-payments/info-movimiento/${paramsToSearch.idmovimiento}`)
            console.log('[useFetchData][useFetchSpecificTransaction] response.data ', response.data)
            // return response.data
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idmovimiento !== '' ){
            console.log(' aquiiiii ')
            setLoadingFetchTransactions(true)
            fetchData()
                .then((resp) => {
                    // setDataSpecificTransaction(resp.rows)
                    setDataSpecificTransaction(resp.data)

                    // Para extraer info de un solo contenedor
                    if(paramsToSearch.fecthTransactionInfo?.flag){

                        paramsToSearch.fecthTransactionInfo.refSetFormState(prevState => ({
                            ...prevState,
                            idmovimiento: resp.data.idmovimiento,
                            idpago: resp.data.idpago,
                            idcaja: resp.data.caja,
                            idbanco: resp.data.idbanco,
                            movimiento_fecha: resp.data.movimiento_fecha,
                            movimiento_tipo: resp.data.movimiento_tipo,
                            movimiento_monto: resp.data.movimiento_monto,
                            movimiento_moneda: resp.data.movimiento_moneda,
                            movimiento_tipo_cambio: resp.data.movimiento_tipo_cambio,
                            movimiento_quetzales: resp.data.movimiento_quetzales,
                            movimiento_dolares: resp.data.movimiento_dolares,
                            movimiento_observaciones: resp.data.movimiento_observaciones,
                            boleta_numero: resp.data.boleta_numero,
                            boleta_foto_originalname: resp.data.boleta_foto_originalname,
                            boleta_foto_filename: resp.data.boleta_foto_filename,
                            boleta_foto_path: resp.data.boleta_foto_path,
                            aprobacion_check: resp.data.aprobacion_check,
                            aprobacion_fecha: resp.data.aprobacion_fecha,
                            aprobacion_observaciones: resp.data.aprobacion_observaciones
                        }))

                    }

                    setLoadingFetchTransactions(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchTransactions(false)
                })
        }
    }, [execute])

    return { dataSpecificTransaction, loadingFetchTransactions, setParamsToSearch, executeFetch, resetFetch }

}

export const useFetchAllBanks = ({marvarApi, dispatch, onLogout}) => {
    
    const [banks, setBanks] = useState([])

    const [ loadingFetchBanks, setLoadingFetchBanks ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }
    
    const resetFetch = async () => {
        setBanks([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/leases/common/fetch-all-banks`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchBanks(true)
        fetchData()
            .then((resp) => {
                const { data } = resp

                setBanks(data)
                setLoadingFetchBanks(false)

            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchBanks(false)
            })
    }, [execute])

    return { banks, loadingFetchBanks, executeFetch, resetFetch }
}